/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Psm_BlockInputs */

const en_ocr_psm_block = /** @type {(inputs: Ocr_Psm_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text Block (Recommended)`)
};

const fr_ocr_psm_block = /** @type {(inputs: Ocr_Psm_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloc de texte (recommandé)`)
};

const de_ocr_psm_block = /** @type {(inputs: Ocr_Psm_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Textblock (Empfohlen)`)
};

const it_ocr_psm_block = /** @type {(inputs: Ocr_Psm_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blocco di testo (consigliato)`)
};

const ru_ocr_psm_block = /** @type {(inputs: Ocr_Psm_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текстовый блок (рекомендуется)`)
};

const es_ocr_psm_block = /** @type {(inputs: Ocr_Psm_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloque de texto (recomendado)`)
};

const zh_cn2_ocr_psm_block = /** @type {(inputs: Ocr_Psm_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文本块（推荐）`)
};

const ja_ocr_psm_block = /** @type {(inputs: Ocr_Psm_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストブロック（推奨）`)
};

const hi_ocr_psm_block = /** @type {(inputs: Ocr_Psm_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टेक्स्ट ब्लॉक (अनुशंसित)`)
};

const pt_pt2_ocr_psm_block = /** @type {(inputs: Ocr_Psm_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloco de texto (recomendado)`)
};

/**
* | output |
* | --- |
* | "Text Block (Recommended)" |
*
* @param {Ocr_Psm_BlockInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_psm_block = /** @type {((inputs?: Ocr_Psm_BlockInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Psm_BlockInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_psm_block(inputs)
	if (locale === "de") return de_ocr_psm_block(inputs)
	if (locale === "it") return it_ocr_psm_block(inputs)
	if (locale === "ru") return ru_ocr_psm_block(inputs)
	if (locale === "es") return es_ocr_psm_block(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_psm_block(inputs)
	if (locale === "ja") return ja_ocr_psm_block(inputs)
	if (locale === "hi") return hi_ocr_psm_block(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_psm_block(inputs)
	return en_ocr_psm_block(inputs)
});